module.exports = __webpack_public_path__ + "static/studio-illustration-5f56f1a032825d74d569109f2c80c9ae.svg";